import { TabHeadingProps, tabConfigProps } from 'processhub-components-lib/dist/lib/types/dashboard';
import React from 'react';
import classNames from '../../utilities/ClassNames';
import TextOverflow from '../../utilities/TextOverflow';



const TabsHeading: React.FC<TabHeadingProps> = ({ tabs, currentTab, setCurrentTab }) => {
  return (
    <>
      {tabs.map((tab: tabConfigProps, index: number) => (
        <div
          onClick={() => setCurrentTab(index)}
          key={`${tab.id}-${index}`}
          className="text-white text-sm h-full cursor-pointer whitespace-nowrap duration-300 capitalize font-bold"
        >
          <span className={""}>
            {TextOverflow(tab.name, 20)}
          </span>
        </div>
      ))}
    </>
  );
};

export default TabsHeading; 
